// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.student-block-container {
  border-radius: 10px;
  border: 1px solid #A7A9AC;
  display: flex;
  color: #333;
  margin: 20px 0;
  min-height: 160px;
  min-width: 500px;
  padding: 5px;
  width: 50%;
}
.student-block-container .photo-container {
  border-radius: 10px;
  height: 170px;
  margin: auto 0;
  margin-left: -5px;
  margin-top: 2px;
  width: 170px;
}
.student-block-container .photo-container .student-image {
  width: 100%;
  height: 100%;
}
.student-block-container .photo-container img {
  border: 1px solid #333333;
}
.student-block-container .student-info-container {
  height: 166px;
  width: 600px;
  font-weight: 550;
}
.student-block-container .student-info-container .student-name {
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 14px;
}
.student-block-container .student-info-container p {
  margin: -10px 0;
  font-size: 0.9rem;
}
.student-block-container .student-info-container p span {
  margin-left: 10px;
  font-weight: 400;
}
.student-block-container .student-info-container table {
  margin: -10px 0 -10px 0;
}
.student-block-container .student-info-container table > tbody > tr > td {
  height: 5px;
  padding: -10;
  font-size: 0.9rem;
}
.student-block-container .student-info-container table > tbody > tr > td > i {
  font-size: 0.9rem;
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/StudentInfoBlock.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;ECAI,mBDCsB;EACtB,yBAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;AAUJ;AARI;ECXA,mBDY0B;EACtB,aAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;AAUR;AARQ;EACI,WAAA;EACA,YAAA;AAUZ;AARQ;EACI,yBAAA;AAUZ;AAPI;EACI,aAAA;EACA,YAAA;EACA,gBAAA;AASR;AARQ;EACI,kBAAA;EACA,gBAAA;EACA,mBAAA;AAUZ;AARQ;EACI,eAAA;EACA,iBAAA;AAUZ;AATY;EACI,iBAAA;EACA,gBAAA;AAWhB;AARQ;EACI,uBAAA;AAUZ;AARQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAUZ;AARQ;EACI,iBAAA;EACA,gBAAA;AAUZ","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// Guardian Dashboard colors\n$lt-blue: #7DB7CC;\n$dk-blue: #19608f;\n\n$error: #CE3525;\n$error-dk: #aa3333;\n$error-hover: #cf4635;\n$hover-white: #E0E0E0;\n$light-background: #EFEFEF;\n\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$green: #4a8319;\n\n$important: #FEBF31;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pale-blue: #C0DEF0;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n$icon-blue: #4DD9FF;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.student-block-container {\n    @include borderRadius(10px);\n    border: 1px solid $grey2;\n    display: flex;\n    color: #333;\n    margin: 20px 0;\n    min-height: 160px;\n    min-width: 500px;\n    padding: 5px;\n    width: 50%;\n\n    .photo-container {\n        @include borderRadius(10px);\n        height: 170px;\n        margin: auto 0;\n        margin-left: -5px;\n        margin-top: 2px;\n        width: 170px;\n\n        .student-image {\n            width: 100%;\n            height: 100%;\n        }\n        img {\n            border: 1px solid #333333;\n        }\n    }\n    .student-info-container {\n        height: 166px;\n        width: 600px;\n        font-weight: 550;\n        .student-name {\n            font-size: 1.25rem;\n            font-weight: 700;;\n            margin-bottom: 14px;\n        }\n        p {\n            margin: -10px 0;\n            font-size: 0.9rem;\n            span {\n                margin-left: 10px;\n                font-weight: 400;\n            }\n        }\n        table {\n            margin: -10px 0 -10px 0;\n        }\n        table>tbody>tr>td {\n            height: 5px;\n            padding: -10;\n            font-size: 0.9rem;\n        }\n        table>tbody>tr>td>i {\n            font-size: 0.9rem;\n            font-weight: 400;\n        }\n    }\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowCustom($hor: 1px, $vert: 1px, $blur: 2px, $color: $shadow) {\n    box-shadow: $hor $vert $blur $color;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
